export default () => import(/* webpackChunkName: 'coffee/activities/auto-renew-intro' */ './AutoRenewUpgrade');
